import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { CourseService } from 'src/app/services/course.service';
@Component({
  selector: 'app-view-quiz',
  templateUrl: './view-quiz.component.html',
  styleUrls: ['./view-quiz.component.scss']
})
export class ViewQuizComponent implements OnInit {

  constructor(private courseService: CourseService, private toastrService: ToastrService) { }
  @Input() quiz: any;
  @Input() moduleId: any;
  @Input() courseId: any;
  @Output() isComplete: EventEmitter<any> = new EventEmitter()
  public activeIndex: any = 0;
  public quizzesForm: FormGroup;
  public questionGroup: FormGroup;
  public quizSubmitted: boolean = false;


  ngOnChanges(changes: SimpleChange) {
    if (changes['quiz']) {
      this.activeIndex = 0;
      this.quizzesForm = new FormGroup({
        questions: new FormArray([])
      });
      this.quizSubmitted = this.quiz.testTaken;
      if(this.quiz.testTaken){
        for (let i = 0; i < this.quiz.test.length; i++) {
          this.questionGroup = new FormGroup({
            question: new FormControl(this.quiz.test[i].question),
            options: new FormControl(_.cloneDeep(this.quiz.test[i].options)),
            chosenAnswer: new FormControl(this.quiz.test[i].chosenAnswer, [Validators.required]),
            correctAnswer: new FormControl(this.quiz.test[i].correctAnswer)
          });
          (this.quizzesForm.get('questions') as FormArray).push(_.cloneDeep(this.questionGroup));
        }
      } else {
        for (let i = 0; i < this.quiz.questions.length; i++) {
          this.questionGroup = new FormGroup({
            question: new FormControl(this.quiz.questions[i].question),
            options: new FormControl(_.cloneDeep(this.quiz.questions[i].options)),
            chosenAnswer: new FormControl('', [Validators.required]),
            correctAnswer: new FormControl('')
          });
          (this.quizzesForm.get('questions') as FormArray).push(_.cloneDeep(this.questionGroup));
        }
      }
    }
  }
  ngOnInit(): void {

  }

  onClickNext() {
    this.activeIndex = this.activeIndex + 1;
  }

  onClickBack() {
    this.activeIndex = this.activeIndex - 1;
  }

  onClickRadioBtn(option) {
    (this.quizzesForm.get('questions') as FormArray).at(this.activeIndex).get('chosenAnswer').setValue(option);
  }

  onClickSubmit() {
    this.courseService.validateQuiz(this.courseId, this.moduleId, this.quiz._id, this.quizzesForm.value).subscribe(
      (res: any) => {
        this.quizSubmitted = true;
        this.toastrService.success('Your Score: ' + (res.correctAnswers / res.totalNumberOfQuestions) * 100 + '%')
        let questions = this.quizzesForm.get('questions') as FormArray;
        for (let i = 0; i < questions.value.length; i++) {
          console.log(questions.at(i))
          questions.at(i).get('correctAnswer').setValue(res.actualAnswers[questions.at(i).get('question').value]);
        }
        this.isComplete.emit(true);
      },
      (err: any) => {
        this.quizSubmitted = false;
        this.toastrService.error(err.error.message)
        this.isComplete.emit(false);
      }
    )
  }

}
